import React, { useRef } from 'react';
import imgPresentacion from '../assets/imagenFondo.jpg';
import videoPresentacion from '../assets/videoFondo.mp4'
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router';

const Inicio = ({ scrollToProductos }) => {
    const scrollToSection = () => {
        scrollToProductos.current?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <>
            <SectionInicio>
            <ImgPresentacionContainer>
                <video
                    src={videoPresentacion}
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster={imgPresentacion}
                />
            </ImgPresentacionContainer>
                <motion.h1
                initial={{ opacity: 0, scale: .3, y:30 }}
                animate={{ opacity: 1, scale: 1, y:0 }}
                transition={{
                    duration: 1,
                    scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                }}
                whileHover={{ scale: 1.2 }}
                
                >
                    Fabrica de persianas<br></br>
                   Hi Blinds
                </motion.h1>
                <motion.div
                initial={{ opacity: 0, y: 30, scale: .7 }}
                animate={{ opacity: 1, y: 0, scale: 1  }}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.5, delay: .2}}
                >
                   <BtnAccionInicio onClick={scrollToSection}>
                        <h3>Ve nuestros productos</h3>
                    </BtnAccionInicio>
                </motion.div>
                
            </SectionInicio>
            <SobreNosotros>
                <motion.h3
                initial={{ opacity: 0, scale: .3, y:30 }}
                animate={{ opacity: 1, scale: 1, y:0 }}
                transition={{
                    duration: .4,
                    scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                }}>
                    Hi Blinds
                </motion.h3>
                <motion.p 
                initial={{ opacity: 0, scale: .3, y:70 }}
                animate={{ opacity: 1, scale: 1, y:0 }}
                transition={{
                    duration: .4,
                    scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                }}>
                    Con más de 50 años de experiencia en el mundo de los tejidos, somos una empresa 100% comprometida con ofrecer productos de la más alta calidad. Garantizando telas de alta calidad, premium y un firme compromiso con la entrega puntual y eficiente a cada uno de nuestros clientes.
                </motion.p>
            </SobreNosotros>
        </>
        
     );
}
const SectionInicio = styled.section `
    margin-bottom: 10px;
    height: 100vh;
    position: static;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
        position: relative;
        z-index: 20;
        color: #fff;
        text-align: center;
    }
`
const ImgPresentacionContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    z-index: 0; // Fondo más bajo

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #0008, #000f);
        z-index: 1;
    }

    video {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        transform: translate(-50%, -50%);
        object-fit: cover;
        z-index: 0;
    }
`;

const BtnAccionInicio = styled.button `
    background-color: #002A48;
    color: #fff;
    border: 1px solid #fefeff;
    padding: 10px 30px;
    border-radius: 10px;
    z-index: 10;
    transform: scale(1);
    transition: transform .3s, background .4s;

    &:active{
        transform: scale(.7);
    }&:hover{
        background-color: #00101b;
    }
    a {
        color: #fff;
        text-decoration: none;
    }
    
`
const SobreNosotros = styled.div `
    background-image: linear-gradient(180deg, #0001,#000f);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;
    position: absolute;
    bottom: 0;
    width: 100%;
    color: #fff;

    h3 {
        text-align: center;
    }
    p {
        text-align: center;
    }
`
export default Inicio;